import { render } from "./AppMessageFileSelector.vue?vue&type=template&id=33b41c39&scoped=true&ts=true"
import script from "./AppMessageFileSelector.vue?vue&type=script&lang=ts"
export * from "./AppMessageFileSelector.vue?vue&type=script&lang=ts"

import "./AppMessageFileSelector.vue?vue&type=style&index=0&id=33b41c39&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b41c39"]])

export default __exports__